import { type ChipPillColors } from '@/components/Common/SeverityPill';
import { formatDateTimeWithOffset } from '@/utils/date-utils';

export type ApiKeyStatus = 'idle' | 'pending' | 'success' | 'error';
export type AutoCreateMode = 'single_step' | 'two_step';

/** What the key opens: a cluster or a serverless space. */
export type ApiKeyResource = {
  kind: 'cluster' | 'space';
  name: string;
  /** Unset while the endpoint is still provisioning. */
  endpointUrl: string | undefined;
  /** Whether keys with custom permissions can be created for this resource from its API Keys tab. */
  canCreateCustomPermissionKeys: boolean;
};

/** The status label of a key past its expiry, whichever API it comes from. */
export const EXPIRED_STATUS_LABEL = 'Expired';

export type ApiKeyViewStatus = {
  label: string;
  color: ChipPillColors;
  busy?: boolean;
  reason?: string;
};

export type ApiKeyViewAccess = { scope: 'global'; label: string } | { scope: 'collections'; labels: string[] };

/** Common shape for cluster and space keys, which come from different protos. */
export type ApiKeyView = {
  id: string;
  name: string;
  postfix: string;
  createdAt?: Date;
  expiresAt?: Date;
  /** Unset when the API does not name the creator: space keys only carry a user id. */
  createdBy?: string;
  status: ApiKeyViewStatus;
  access: ApiKeyViewAccess | null;
  deletable: boolean;
};

export const formatApiKeyDate = (date?: Date): string => (date ? formatDateTimeWithOffset({ date }) : '-');

export const maskApiKey = (postfix: string) => `********${postfix}`;
